export enum ServiceWorkerType {
  security = <any>'security',
  serverCache = <any>'serverCache'
}
